// FIXME move under flutter
type FlutterMessage = {
  postMessage: (message: string) => void;
};

declare global {
  // eslint-disable-next-line no-var
  var platformLocationOpen: FlutterMessage;
}

interface LocationData {
  lat: number;
  lon: number;
  title: string;
}

function isPlatformLocationOpenAvailable(): boolean {
  return window.platformLocationOpen !== undefined;
}

function postLocationOpenOnMap(location: LocationData, routing: boolean) {
  let locationOpenMessage = JSON.stringify({
    lat: location.lat,
    lon: location.lon,
    title: location.title,
    routing: routing,
  });
  // ha a lat vagy lon egesz, akkor a jsonban nincs tizedes
  // es akkor nem mukodik :(
  locationOpenMessage = locationOpenMessage.replace(/:(\d+),/g, ':$1.0000,');
  window.platformLocationOpen.postMessage(locationOpenMessage);
}

export function openLocation(location: LocationData) {
  if (isPlatformLocationOpenAvailable()) {
    postLocationOpenOnMap(location, false);
    return;
  }

  const locationUrl = `https://www.google.com/maps?q=${location.lat},${location.lon}`;
  window.open(locationUrl, '_blank', 'noopener=true,noreferrer=true');
}

export function routeLocation(location: LocationData) {
  if (isPlatformLocationOpenAvailable()) {
    postLocationOpenOnMap(location, true);
    return;
  }

  const locationUrl = `https://www.google.com/maps/dir/?api=1&destination=${location.lat},${location.lon}&travelmode=driving`;
  window.open(locationUrl, '_blank', 'noopener=true,noreferrer=true');
}
